module.exports = __webpack_public_path__ + "static/media/login-background2.be15c698.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-background2.png
// module id = 1102
// module chunks = 114